import type { ConfirmScratchpadPayload } from "../../../../api/healthcare/ScratchpadApi";
import type { UserUuid } from "../../../../types/identity";

/** Sections the scratchpad can create into (mirrors the backend CreatorRegistry). */
export const SCRATCHPAD_SECTIONS = [
	{ label: "Auto-detect", value: "" },
	{ label: "Medical History", value: "medical_history" },
	{ label: "Medication", value: "medications" },
	{ label: "Vital Signs", value: "vital_signs" },
	{ label: "Referral", value: "referrals" },
	{ label: "Personal Info", value: "personal_info" },
];

/**
 * Maps a section / linked_item_type to the PatientModal tab key it lives under, for deep-linking
 * the created item from a completed note. (Vitals/referrals have no dedicated tab yet → Overview.)
 */
export const SECTION_TO_TAB: Record<string, string> = {
	medical_history: "Medical History",
	medications: "Medications",
	vital_signs: "Overview",
	referrals: "Overview",
	personal_info: "Personal",
};

/** Human label for a section / linked_item_type. */
export const sectionLabel = (section: string): string =>
	SCRATCHPAD_SECTIONS.find((s) => s.value === section)?.label ?? section.replace(/_/g, " ");

/** The PatientModal tab key for a section, or undefined when there is no mapped tab. */
export const tabForSection = (section?: string | null): string | undefined =>
	section ? SECTION_TO_TAB[section] : undefined;

/**
 * Build the confirm payload for a reviewed draft. Kept pure so it can be unit-tested without
 * rendering the (import.meta / ReactQuill-heavy) Notes component.
 */
export const buildConfirmPayload = (args: {
	section: string;
	draft: Record<string, any>;
	body?: string;
	actorId: UserUuid;
	actorRole?: string;
}): ConfirmScratchpadPayload => ({
	section: args.section,
	draft: args.draft,
	body: args.body,
	actor_id: args.actorId,
	actor_role: args.actorRole,
});
